import React from 'react';
import { MyContext } from "../context";
import { Images } from '../components';
import { Modal } from "react-bootstrap";

import {  UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap';
import FeedFooterRow from './../components/FeedFooterRow';
import FeedCommentPost from './../components/FeedCommentPost';
import UtilityFunctions from '../helper/UtilityFunctions';
import _ from "lodash";

import WSManager from "../helper/WSManager";
import { notify } from "react-notify-toast";
import ReactHtmlParser from 'react-html-parser';
import * as NC from '../helper/NetworkingConstants'
import { SRLWrapper } from "simple-react-lightbox";

import SimpleReactLightbox from 'simple-react-lightbox'
import { UnFollowModal } from '../Modals';
import Config from '../Config';


class FeedList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showUnFollowModal:false,
            showDeleteModal:false,
            isRemoved:false,
            parentIsFollower: 0,
            playingVideos: {},
        }
    }




     showUnFollowModal = () => {
        this.setState({
          showUnFollowModal: true,
        });
      };

      UnFollowModalHide = () => {
        this.setState({
            showUnFollowModal: false
        });
      };

      showDeleteModal = () => {
        this.setState({
            showDeleteModal: true
        });
      };

      hideDeleteModal = () => {
        this.setState({
            showDeleteModal: false
        });
      };

      confirmDelete = () => {
        this.hideDeleteModal();
        this.handleFeedAction('delete', this.props.feedItem);
      };

      handleFeedAction = (action, feedItem) => {
        if (this.props.onFeedAction) {
            this.props.onFeedAction(action, feedItem);
            return;
        }

        if (action == 'hide' || action == 'delete' || action == 'block') {
            this.setState({ isRemoved: true });
        }
        if (action == 'edit' && this.props.history) {
            this.props.history.push({
                pathname: '/create-post',
                state: { feedItem: feedItem, isEdit: true }
            });
            return;
        }
        notify.show('Action completed successfully.', "success", 2500);
      };

      getMediaType = (item) => {
        return String((item && (item.media_type || item.type || item.mime_type)) || "");
      };

      isPdfMedia = (item) => {
        const mediaType = this.getMediaType(item);
        const mediaPath = String(this.getMediaPath(item) || "");
        return mediaType.toLowerCase().indexOf("pdf") > -1 || mediaPath.toLowerCase().indexOf(".pdf") > -1;
      };

      isAudioMedia = (item) => {
        const mediaType = this.getMediaType(item).toLowerCase();
        const mediaPath = String(this.getMediaPath(item) || "").toLowerCase();
        return mediaType.indexOf("audio") === 0 || /\.(mp3|wav|ogg|m4a|aac)$/i.test(mediaPath);
      };

      isVideoMedia = (item) => {
        const mediaType = this.getMediaType(item).toLowerCase();
        const mediaPath = String(this.getMediaPath(item) || "").toLowerCase();
        return mediaType.indexOf("video") === 0 || /\.(mp4|mov|webm|m4v)$/i.test(mediaPath);
      };

      getMediaPath = (item) => {
        return item ? String(item.media_path || item.image_path || item.file_path || "") : "";
      };

      getMediaUrl = (item) => {
        const mediaPath = this.getMediaPath(item);
        if (mediaPath.indexOf("http") === 0) {
            return mediaPath;
        }
        return NC.s3_dev + mediaPath;
      };

      getMediaName = (item) => {
        const mediaPath = this.getMediaPath(item);
        return (item && (item.file_name || item.media_name || item.name)) || mediaPath.split('/').pop() || "Document.pdf";
      };

      getPdfViewerUrl = (item) => {
        const mediaUrl = this.getMediaUrl(item);
        return `${mediaUrl}${mediaUrl.indexOf("#") > -1 ? "&" : "#"}toolbar=0&navpanes=0&scrollbar=1`;
      };

      hasParentActivity = (feedItem) => {
        return feedItem.parent_activity_id && feedItem.parent_activity_id != '' && feedItem.parent_activity_id != '0';
      };

      isQuotePost = (feedItem) => {
        return this.hasParentActivity(feedItem) && (feedItem.post_title);
      };

      getFeedContent = (feedItem) => {
        return this.isQuotePost(feedItem) ? (feedItem.post_title || '') : (feedItem.post_content || '');
      };

      getQuotedContent = (feedItem) => {
        // Backend copies the original post_content into the quote post record;
        // parent_post_title may also be returned by some API versions.
        return feedItem.parent_post_title || feedItem.post_content || '';
      };

      handleParentFollowUnfollow = (e, feedItem) => {
        e.stopPropagation();
        if (!WSManager.loggedIn()) {
            window.location.href = Config.RefpredictorUrl;
            return;
        }
        const { parentIsFollower } = this.state;
        const api = NC.baseURL + (parentIsFollower === 1 ? NC.USER_UNFOLLOW : NC.USER_FOLLOW);
        WSManager.Rest(api, { follower_id: feedItem.parent_user_id }).then(responseJson => {
            if (responseJson.response_code === NC.successCode) {
                this.setState({ parentIsFollower: responseJson.data.is_follow });
            }
        });
      };

      getQuotedGallery = (feedItem) => {
        const gallery = feedItem.gallery || [];

        return Array.isArray(gallery) ? gallery : [];
      };

      isParentPostDeleted = (feedItem) => {
        return Number(feedItem.parent_is_deleted) == 1
            || Number(feedItem.parent_activity_deleted) == 1
            || Number(feedItem.parent_activity_status) == 2
            || (!this.getQuotedContent(feedItem) && this.getQuotedGallery(feedItem).length === 0);
      };

      renderQuoteMedia = (feedItem) => {
        const quoteGallery = this.getQuotedGallery(feedItem);
        const quoteGalleryLength = quoteGallery.length;
        const mediaLayoutClass = quoteGalleryLength === 3 ? ' media-count-3' : '';

        if (quoteGalleryLength === 0) {
            return null;
        }

        return (
            <div className={'quote-feed-card-media' + (quoteGalleryLength == 1 ? ' single' : mediaLayoutClass)}>
                <SimpleReactLightbox>
                    <SRLWrapper options={quoteGalleryLength == 1 ? this.getSingleMediaOptions() : this.getMediaOptions()}>
                        {
                            quoteGallery.map((imageItem, imageIndex) => {
                                return this.renderFeedMedia(imageItem, imageIndex, quoteGalleryLength);
                            })
                        }
                    </SRLWrapper>
                </SimpleReactLightbox>
            </div>
        );
      };

      renderQuotePost = (feedItem) => {
        if (!this.isQuotePost(feedItem)) {
            return null;
        }
        const quotedContent = this.getQuotedContent(feedItem);
        const isParentPostDeleted = this.isParentPostDeleted(feedItem);
        const parentName = feedItem.display_name || feedItem.user_name || '';
        const parentHandle = feedItem.user_name ? '@' + feedItem.user_name : '';

        return (
            <div className={'quote-feed-card ' + (isParentPostDeleted ? 'deleted-parent-post' : '')} onClick={() => isParentPostDeleted ? '' : this.props.goToPostDetail(feedItem)}>
                {!isParentPostDeleted && (
                    <div className="quote-feed-card-hdr">
                        <img
                            className="quote-user-avatar"
                            src={feedItem.user_image && feedItem.user_image !== '' ? feedItem.user_image : Images.DEFAULT_USER}
                            alt=""
                            onError={(e) => { e.target.src = Images.DEFAULT_USER; }}
                        />
                        <div className="quote-user-info">
                            {parentName && <h6>{parentName}</h6>}
                            {parentHandle && <span className="quote-username">{parentHandle}</span>}
                        </div>
                        {WSManager.loggedIn() && feedItem.user_id && Number(feedItem.user_id) !== Number(WSManager.getProfile().user_id) && (
                            <span
                                className="ad-ic quote-follow-btn"
                                onClick={(e) => this.handleParentFollowUnfollow(e, feedItem)}
                            >
                                <i className={this.state.parentIsFollower === 1 ? 'icon-user-select' : 'icon-refer-ic'} />
                            </span>
                        )}
                    </div>
                )}
                {
                    isParentPostDeleted
                        ?
                        <div className="quote-feed-card-content deleted-post-text">This post has been deleted.</div>
                        :
                        quotedContent &&
                        <div className="quote-feed-card-content">{ReactHtmlParser(quotedContent)}</div>
                }
                {!isParentPostDeleted && this.renderQuoteMedia(feedItem)}
            </div>
        );
      };

      renderPdfMedia = (item) => {
        const mediaName = this.getMediaName(item);

        return (
            <div className="pdf-viewer-card">
                <iframe
                    title={mediaName}
                    className="pdf-viewer-frame"
                    src={this.getPdfViewerUrl(item)}
                />
            </div>
        );
      };

      renderAudioMedia = (item) => {
        return (
            <div className="feed-audio-card">
                <div className="feed-audio-title">
                    <i className="icon-mick" />
                    <span>{this.getMediaName(item)}</span>
                </div>
                <audio src={this.getMediaUrl(item)} controls />
            </div>
        );
      };

      setVideoPlaying = (item, isPlaying) => {
        const videoKey = this.getMediaPath(item);

        this.setState({
            playingVideos: {
                ...this.state.playingVideos,
                [videoKey]: isPlaying
            }
        });
      };

      toggleVideoPlayback = (event, shouldStopPropagation = true) => {
        event.preventDefault();
        if (shouldStopPropagation) {
            event.stopPropagation();
        }

        const videoWrapper = event.currentTarget.closest('.feed-video-wrapper');
        const video = videoWrapper && videoWrapper.querySelector('video');

        if (!video) {
            return;
        }

        if (video.paused) {
            const playPromise = video.play();
            if (playPromise && playPromise.catch) {
                playPromise.catch(() => {});
            }
        }
        else {
            video.pause();
        }
      };

      renderVideoMedia = (item) => {
        const videoKey = this.getMediaPath(item);
        const isPlaying = this.state.playingVideos[videoKey];

        return (
            <div className="feed-video-wrapper" onClick={(event) => this.toggleVideoPlayback(event, false)}>
                <video
                    className="feed-video-player"
                    src={this.getMediaUrl(item)}
                    controls
                    playsInline
                    onPlay={() => this.setVideoPlaying(item, true)}
                    onPause={() => this.setVideoPlaying(item, false)}
                    onEnded={() => this.setVideoPlaying(item, false)}
                />
                <button
                    type="button"
                    className={`feed-video-toggle ${isPlaying ? 'is-playing' : ''}`}
                    onClick={this.toggleVideoPlayback}
                    aria-label={isPlaying ? 'Pause video' : 'Play video'}
                />
            </div>
        );
      };

      renderFeedMedia = (imageItem, imageIndex, galleryLength = 1) => {
        const slicedArrayLength = Math.min(galleryLength, 4);
        const extraClass = galleryLength > 4 && imageIndex == 3 ? 'overlay-count' : imageIndex > 3 ? 'none' : '';
        const isPdf = this.isPdfMedia(imageItem);
        const isAudio = this.isAudioMedia(imageItem);
        const isVideo = this.isVideoMedia(imageItem);

        return (
            <div className={`content-image ${isPdf ? 'pdf-media' : ''} ${isAudio ? 'audio-media' : ''} ${isVideo ? 'video-media' : ''} ${extraClass}`} key={imageIndex}>
                {
                    isPdf
                        ?
                        this.renderPdfMedia(imageItem)
                        :
                        isVideo
                            ?
                            this.renderVideoMedia(imageItem)
                            :
                            isAudio
                                ?
                                this.renderAudioMedia(imageItem)
                        :
                        <img alt="" src={this.getMediaUrl(imageItem)} />
                }
                {galleryLength > 4 && imageIndex == 3 && <h4 className="count-image">+{galleryLength - slicedArrayLength}</h4>}
            </div>
        );
      };

      getMediaOptions = () => {
        return {
            settings: {
                overlayColor: "rgb(0, 0, 0)",
            },
            buttons:{
                showAutoplayButton:false,
                showDownloadButton:false,
                showThumbnailsButton:false,
                showFullscreenButton:false
            },
            disablePanzoom: false,
            disableWheelControls: false,
            hideControlsAfter: true,
            showThumbnailsButton :false,
            thumbnails: {
                showThumbnails: false
            }
        }
      };

      getSingleMediaOptions = () => {
        return {
            settings: {
                overlayColor: "rgb(0, 0, 0)",
            },
            buttons:{
                showAutoplayButton:false,
                showDownloadButton:false,
                showThumbnailsButton:false,
                showFullscreenButton:false,
                showNextButton:false,
                showPrevButton:false,
            },
            disablePanzoom: false,
            disableWheelControls: false,
            hideControlsAfter: true,
            showThumbnailsButton :false,
            thumbnails: {
                showThumbnails: false
            }
        }
      };






    render() {



        const {feedItem, feedIndex, feedItemFooterProps, FeedCommentPostProps, selectedItem, goToPostDetail, isShowRepost,showUnFollowModal  } = this.props
        const galleryLength = feedItem.gallery ? feedItem.gallery.length : 0;
        const mediaLayoutClass = galleryLength === 3 ? ' media-count-3' : '';
        if (this.state.isRemoved) {
            return null;
        }


        const options = this.getMediaOptions();
        const optionsSignle = this.getSingleMediaOptions();

        const hasPostTitle = feedItem.post_title && feedItem.post_title.trim() !== "";

        const profileImage = hasPostTitle
            ? (feedItem.parent_user_image || Images.DEFAULT_USER)
            : (feedItem.user_image || Images.DEFAULT_USER);

        const profileName = hasPostTitle
            ? (feedItem.parent_display_name || "User")
            : (feedItem.display_name || "User");

        const userName = hasPostTitle
            ? (feedItem.parent_user_name || "user")
            : (feedItem.user_name || "user");
        return (

            <MyContext.Consumer>

                {context => (
                    <React.Fragment>
                        <div className={'feed-box ' + (!isShowRepost ? 'comments-list' : '')}>
                            {
                                (!_.isNull(feedItem.parent_activity_id) && Number(feedItem.parent_activity_id) !== 0 && isShowRepost && !this.isQuotePost(feedItem)) &&
                                <div className="respost-feed-block">
                                    <img src={require('../assets/img/repost.svg')}></img>
                                    <span onClick={() => this.props.goToUserProfile((feedItem.parent_user_id))} className = {'user-name'}>{feedItem.parent_display_name}</span>
                                    <span>
                                        {' reposted'}
                                    </span>
                                </div>

                            }
                            <div className={'feed-hdr'}>
                                <div className={'l-p'}>
                                    <span className={'prof-pic'}>
                                        <img
                                            onClick={() => {
                                                if (!WSManager.loggedIn()) {
                                                    window.location.href = Config.RefpredictorUrl;
                                                    return;
                                                }

                                                this.props.goToUserProfile(feedItem.user_id);
                                            }}
                                            src={profileImage}
                                            alt=""
                                        />
                                    </span>

                                    <div className={'prof-det'}>
                                        <h6
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                if (!WSManager.loggedIn()) {
                                                    window.location.href = Config.RefpredictorUrl;
                                                    return;
                                                }

                                                this.props.goToUserProfile(feedItem.user_id);
                                            }}
                                        >
                                            {profileName}
                                        </h6>

                                        <div className={'usrnm-lb'}>
                                            {'@' + userName}
                                        </div>

                                        <div className={'tm-ago'}>
                                            {UtilityFunctions.getUtcToLocalFromNow(feedItem.created_date)}
                                        </div>
                                    </div>
                                </div>
                                {<div className={'r-p'}>

                                    {feedItem.user_id !== WSManager.getProfile().user_id && <span onClick={() => {
                                        if (!WSManager.loggedIn()) {
                                            window.location.href = Config.RefpredictorUrl;
                                            return;
                                        }
                                        this.props.followUnfollowUser(feedItem)
                                    }}
                                        className={'ad-ic'}><i className={feedItem.is_follower == 0 ?
                                            'icon-refer-ic' : 'icon-user-select'
                                        } /></span>}
                                    {/* <i className="icon-refer-ic" onClick={this.showUnFollowModal}></i>
                                        <UnFollowModal
                                            IsUnFolloModalShow={showUnFollowModal}
                                            IsUnFolloModalHide={this.UnFollowModalHide}
                                            /> */}

                                    {WSManager.loggedIn() && (
                                        <span>
                                            <UncontrolledDropdown direction={'left'} className={'act-dropdown'}>
                                                <DropdownToggle> <i className={'icon-toggle-vertical'} /></DropdownToggle>
                                                {feedItem.user_id !== WSManager.getProfile().user_id ? <DropdownMenu>
                                                    <DropdownItem onClick={() => this.handleFeedAction('hide', feedItem)}><i className={'icon-hide'} />Hide</DropdownItem>
                                                    <DropdownItem onClick={() => this.handleFeedAction('block', feedItem)}><i className={'icon-block'} />Block</DropdownItem>
                                                    <DropdownItem onClick={() => this.handleFeedAction('report', feedItem)}><i className={'icon-report'} />Report</DropdownItem>
                                                </DropdownMenu> :
                                                    <DropdownMenu>
                                                        <DropdownItem onClick={() => this.handleFeedAction('edit', feedItem)}><i className={'icon-hide'} />Edit</DropdownItem>
                                                        <DropdownItem onClick={this.showDeleteModal}><i className={'icon-block'} />Delete</DropdownItem>
                                                    </DropdownMenu>
                                                }
                                            </UncontrolledDropdown>
                                        </span>)}
                                </div>}
                            </div>
                            <div className={'feed-cntnt ' + (isShowRepost ? 'cursor-pointer' : '')}>
                                <div className={'content-text'} onClick={() => isShowRepost ? goToPostDetail(feedItem) : ''}>
                                    <span>
                                        {ReactHtmlParser(this.getFeedContent(feedItem))}

                                    </span>
                                </div>
                                <div className={'content-tags'} onClick={() => isShowRepost ? goToPostDetail(feedItem) : ''}>

                                    {
                                        feedItem && feedItem.activity_tags && feedItem.activity_tags.map((tagItem, tagIndex) => {
                                            return (
                                                <span>{'#' + tagItem.tag_name + ' '}</span>
                                            )
                                        })
                                    }

                                </div>
                                {this.renderQuotePost(feedItem)}
                                {
                                    !this.isQuotePost(feedItem) && (
                                        feedItem.gallery && feedItem.gallery.length ==1
                                            ?
                                            <div className={'content-media single'}>
                                                 <SimpleReactLightbox>
                                                 <SRLWrapper  options={optionsSignle}>
                                                {
                                                    feedItem && feedItem.gallery && feedItem.gallery.map((imageItem, imageIndex) => {
                                                        return this.renderFeedMedia(imageItem, imageIndex, feedItem.gallery.length);
                                                    })
                                                }
                                                </SRLWrapper>
                                                </SimpleReactLightbox>

                                            </div>
                                            :
                                            <div className={'content-media' + mediaLayoutClass}>
                                                <SimpleReactLightbox>
                                                 <SRLWrapper  options={options}>
                                                {
                                                    //feedItem.gallery.slice(0, 4).map((imageItem, imageIndex) => {
                                                        feedItem && feedItem.gallery && feedItem.gallery.map((imageItem, imageIndex) => {
                                                        return this.renderFeedMedia(imageItem, imageIndex, feedItem.gallery.length);
                                                    })
                                                }
                                                </SRLWrapper>
                                                </SimpleReactLightbox>
                                            </div>
                                    )
                                }
                                {/* for video view  */}
                                {/* {
                                    feedItem.gallery && feedItem.gallery.length > 0
                                        ?
                                        <div className={''}>
                                        <div className="post-view-wrapper">
                                            <div className="viewer-wrapper">
                                                <i className="icon-eye"></i>
                                                <span>15.4 k</span>

                                            </div>
                                            <div className = {'followed-by-container'}>
                                                <div className = 'followed-by-users-image'>
                                                    <img src ={ Images.DEFAULT_USER}/>
                                                    <img src ={ Images.DEFAULT_USER}/>
                                                    <img src ={ Images.DEFAULT_USER}/>
                                                </div>
                                                </div>
                                            </div>

                                        </div>
                                        :
                                        null
                                } */}


                            </div>
                            <div className={'feed-footer'}>
                                <FeedFooterRow feedItemFooterProps={feedItemFooterProps} feedItem={feedItem} feedIndex={feedIndex} history={this.props.history} ></FeedFooterRow>
                            </div>
                            {
                                (selectedItem === feedIndex || !isShowRepost) &&
                                <FeedCommentPost FeedCommentPostProps={FeedCommentPostProps} feedItem={feedItem} />


                            }
                        </div>
                        <Modal
                            show={this.state.showDeleteModal}
                            onHide={this.hideDeleteModal}
                            dialogClassName="alert-modal modal-sm"
                            className="center-modal unfollow-modal"
                        >
                            <Modal.Body>
                                <h2>Alert</h2>
                                <p>Are you sure you want to delete this post?</p>
                                <div className="modal-footer">
                                    <a href
                                        onClick={(e) => { e.preventDefault(); this.confirmDelete(); }}
                                        className="btn bnt-rounded">
                                        Yes
                                    </a>
                                    <a href
                                        onClick={(e) => { e.preventDefault(); this.hideDeleteModal(); }}
                                        className="btn bnt-rounded">
                                        No
                                    </a>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </React.Fragment>
                )}
            </MyContext.Consumer>

        )
    }
}

export default FeedList;
